export default function PromptButton({ children }: { children: React.ReactNode; }) {
    return (
        <div className="prompt-btn border text-sm md:text-md rounded-2xl py-1 px-4 w-fit bg-muted/50 text-muted-foreground cursor-pointer hover:bg-muted hover:text-foreground transition-colors">
            {children}
        </div>
    );
}